import React from "react";
import styled from "styled-components";
import { Typography, Button } from "@plum-xoxo/admin-dsm";

const PaymetntPreview = ({
  status,
  seconds,
  redirectHandler,
  rechargeFailReason,
  isPrimer = false,
  isPayoneer = false,
}) => {
  const heading =
    status === "success"
      ? isPrimer || isPayoneer
        ? "Your payment request is being captured!"
        : "Your payment is successful!"
      : "Your payment has failed!";
  const subHeading =
    status === "success" ? (
      "You will be recieving an email from Xoxoday containing your payment details."
    ) : (
      <>You payment has failed due to {rechargeFailReason}. Please try again.</>
    );
  const image = (
    <img
      height={340}
      width={340}
      src={`/admin/img/payment/wallet-${status}.png`}
      alt="Payment"
    />
  );
  return (
    <div className="d-flex justify-content-center align-items-center mt-200 px-164">
      <div className="d-flex flex-column  flex-wrap">
        <div>
          <Typography.H1 color="dark" shade="c300">
            {heading}
          </Typography.H1>
        </div>
        <div className="mt-4">
          <Typography
            component="div"
            style={{ width: "424px" }}
            color="dark"
            shade="c200"
          >
            {subHeading}
          </Typography>
        </div>
        <div className="mt-24 mb-100 ml-0">
          <Button variant="outlined" color="primary" onClick={redirectHandler}>
            Go Home
          </Button>
        </div>
        <div className="ml-0">
          <Typography.LabelText>
            You are being redirected to Plum Homepage in {seconds} seconds...
          </Typography.LabelText>
        </div>
      </div>
      <div className="ml-200">{image}</div>
    </div>
  );
};

const StyledPaymentPreview = styled(PaymetntPreview).attrs()`
  min-height: 100vh;
`;

export default StyledPaymentPreview;
